import {
    NoteType,
    QcJobStatuses,
} from '@pluto/@types';

export interface QcJobStatusIndicatorStateItem {
    type: NoteType;
    status: QcJobStatuses;
}

export interface QcJobStatusIndicatorState {
    statusIndicators: QcJobStatusIndicatorStateItem[];
    isLoading: boolean;
}

export enum QcJobStatusesEnum {
    visualQc = 'media',
    metadata = 'metadata',
    artwork = 'artwork',
    report = 'validation'
}
